import { render, staticRenderFns } from "./ChangePassWord.vue?vue&type=template&id=71c49285&scoped=true"
import script from "./ChangePassWord.vue?vue&type=script&lang=js"
export * from "./ChangePassWord.vue?vue&type=script&lang=js"
import style0 from "./ChangePassWord.vue?vue&type=style&index=0&id=71c49285&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c49285",
  null
  
)

export default component.exports